<template>
  <page-header-wrapper>

  </page-header-wrapper>
</template>

<template>
  <div class="content-warp">
    <div class="content-panle bg-white" style="position:relative">
      <a-card :bordered="false">
        <a-steps class="steps" :current="currentTab">
          <a-step title="选择商品" />
          <a-step title="确认订单" />
          <a-step title="支付" />
          <a-step title="完成" />
        </a-steps>
        <div class="content">
          <step1 v-if="currentTab === 0" :order="order" @nextStep="nextStep"/>
          <step2 v-if="currentTab === 1" :order="order" @nextStep="nextStep" @prevStep="prevStep"/>
          <step3 v-if="currentTab === 2" :order="order" @nextStep="nextStep" @prevStep="prevStep"/>
          <step4 v-if="currentTab === 3" :order="order" @toOrderList="toOrderList" @finish="finish"/>
        </div>
      </a-card>
    </div>
  </div>
</template>



<script>

const orderForm = {
  amountPerDevice:1,
  deviceType: 1,
  price: 0,
  deviceIds: [],
  goodId: undefined,
  goods:{},
  goodsName: '',
  devices: [],
  payType: undefined,
  payState: undefined
}

import Step1 from './Step1/index'
import Step2 from './Step2/index'
import Step3 from './Step3/index'
import Step4 from './Step4/index'

export default {
  name: 'RechargeForm',
  components: {
    Step1,
    Step2,
    Step3,
    Step4
  },
  data () {
    return {
      order: JSON.parse(JSON.stringify(orderForm)),
      currentTab: 0,
      // form
      form: null
    }
  },
  created() {
    console.log('created---进入商品购买')
  },
  methods: {

    // handler
    nextStep ( data ) {
      console.log(data)
      if (data){
        this.order = data
      }
      if (this.currentTab < 3) {
        this.currentTab += 1
      }
      console.log(this.currentTab)

    },
    prevStep () {
      if (this.currentTab > 0) {
        this.currentTab -= 1
      }
    },
    finish () {
      this.currentTab = 0
      this.order = JSON.parse(JSON.stringify(orderForm))
    },
    toOrderList () {
      this.currentTab = 0
      this.order = JSON.parse(JSON.stringify(orderForm))
      this.$router.push({ name: 'ordersIndex' });
    }
  }
}
</script>

<style lang="less" scoped>
  .steps {
    max-width: 750px;
    margin: 16px auto;
  }
</style>
